<template lang="pug">
  .semibold(:style='"color:" + infrastructureText.color') {{infrastructureText.text}}
</template>

<script>
import { COLORS } from '@/utils'

export default {
  name: 'map-popup-infrastructure',
  props: {
    objects: {
      type: Array,
      default: () => [],
    },
    sumTones: {
      type: Number,
      required: true,
    },
  },
  computed: {
    infrastructureText() {
      const sum = this.objects.reduce((a, b) => a + b.sum_power, 0)
      if (sum < this.sumTones || sum === 0) {
        return {
          color: COLORS.red,
          text: `Инфраструктуры недостаточно для обслуживания всех входящих потоков, не хватает ${Math.abs(
            sum - this.sumTones
          )} тонн мощности объектов, рекомендуется установить новый объект обращения или модернизировать существующий`,
        }
      } else {
        return {
          color: COLORS.green,
          text: 'Инфраструктуры достаточно для обслуживания всех входящих потоков',
        }
      }
    },
  },
}
</script>
